import { toast } from "sonner";

export const PHONE_DISPLAY = "407-374-4236";
export const PHONE_TEL = "+14073744236";
export const EMAIL = "tellmeyourdesire666@gmail.com";

// Gmail compose URL — opens Gmail directly with the "to" field pre-filled
// so visitors can type and send without a desktop mail client.
export const GMAIL_COMPOSE_URL = `https://mail.google.com/mail/?view=cm&fs=1&to=${encodeURIComponent(
    EMAIL
)}&su=${encodeURIComponent("Tell Me Your Desire")}`;

const copyToClipboard = async (text) => {
    try {
        if (navigator.clipboard && window.isSecureContext) {
            await navigator.clipboard.writeText(text);
            return true;
        }
        const textArea = document.createElement("textarea");
        textArea.value = text;
        textArea.style.position = "fixed";
        textArea.style.left = "-9999px";
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        const ok = document.execCommand("copy");
        document.body.removeChild(textArea);
        return ok;
    } catch (error) {
        console.error("Failed to copy to clipboard:", error);
        return false;
    }
};

export const handleCall = async () => {
    const copied = await copyToClipboard(PHONE_DISPLAY);
    if (copied) {
        toast.success("Phone number copied!", {
            description: `${PHONE_DISPLAY} — opening your phone app…`,
        });
    }
    try {
        window.open(`tel:${PHONE_TEL}`, "_self");
    } catch (error) {
        console.error("Failed to open tel: link:", error);
    }
};

export const handleEmail = async (e) => {
    if (e && typeof e.preventDefault === "function") {
        e.preventDefault();
    }
    await copyToClipboard(EMAIL);
    toast.success("Opening Gmail…", {
        description: `Type your message and send it to ${EMAIL}`,
    });
    const win = window.open(GMAIL_COMPOSE_URL, "_blank", "noopener,noreferrer");
    if (!win) {
        window.location.href = GMAIL_COMPOSE_URL;
    }
};
